/**
 * Zentrale Konstanten, die Client und Server teilen.
 * Aenderungen hier wirken auf beide Seiten — bewusst die einzige Quelle.
 */
/** Kantenlaenge eines Tiles in Welt-Pixeln (Render-Basis des Themes). */
export const TILE_SIZE = 32;
/** Laufgeschwindigkeit des Avatars in Tiles pro Sekunde. */
export const PLAYER_SPEED_TILES_PER_S = 5;
/**
 * Rennen: so viel schneller als Gehen. Eingaben melden es als Bewegungs-
 * vektor mit Betrag ueber 1 (Umschalt am Desktop, Joystick weit ueber den
 * Ring hinaus); der Client deckelt den Betrag, der Server das Budget.
 */
export const RENN_FAKTOR = 1.8;
export const PLAYER_RENN_SPEED_TILES_PER_S = PLAYER_SPEED_TILES_PER_S * RENN_FAKTOR;
/** Kollisionsradius des Avatars in Tiles (Kreis um die Fusspunkt-Position). */
export const PLAYER_COLLISION_RADIUS = 0.35;
/** Server-Broadcast-Frequenz fuer Positions-Deltas. */
export const TICK_RATE_HZ = 15;
export const TICK_INTERVAL_MS = Math.round(1000 / TICK_RATE_HZ);
/** Sende-Frequenz des Clients fuer eigene Positionen. */
export const MOVE_SEND_RATE_HZ = 15;
/** Toleranzfaktor der Server-Geschwindigkeitspruefung (Jitter/Latenz-Puffer). */
export const MOVE_SPEED_SLACK = 1.6;
/** Maximal akzeptierte player:move-Events pro Sekunde und Socket. */
export const MOVE_MAX_EVENTS_PER_S = 25;
/** Remote-Avatare werden so viele ms in der Vergangenheit interpoliert. */
export const INTERPOLATION_DELAY_MS = 100;
/**
 * Proximity-Hysterese in Tiles: Verbindung entsteht bei <= ENTER,
 * und loest sich erst wieder bei >= EXIT — verhindert Verbindungs-Flattern.
 */
export const PROXIMITY_ENTER_RADIUS = 3;
export const PROXIMITY_EXIT_RADIUS = 5;
/** Obergrenze gleichzeitiger WebRTC-Peers pro Client (Mesh-Limit). */
export const MAX_ACTIVE_PEERS = 8;
/** Audio-Lautstaerke faellt linear von 1.0 (<= 1 Tile) auf diesen Wert am EXIT-Radius. */
export const SPATIAL_AUDIO_MIN_GAIN = 0.05;
/** Chat-Limits. */
export const CHAT_MAX_LENGTH = 1000;
export const CHAT_PAGE_SIZE = 50;
export const CHAT_PAGE_SIZE_MAX = 100;
/** Token-Bucket: so viele Nachrichten Burst, Nachfuellrate 1/s. */
export const CHAT_BURST_LIMIT = 5;
/** Benutzer- und Anzeigename-Limits. */
export const USERNAME_MIN = 3;
export const USERNAME_MAX = 32;
export const DISPLAY_NAME_MAX = 24;
export const PASSWORD_MIN = 8;
/** Sticky Notes. */
export const NOTE_MAX_LENGTH = 500;
/** Whiteboard: maximale Punkte pro Strich (Schutz vor Riesen-Payloads). */
export const STROKE_MAX_POINTS = 2000;
/** Anklingeln: Klingelversuch laeuft clientseitig nach dieser Zeit aus (auto-cancel). */
export const RING_TIMEOUT_MS = 30_000;
/**
 * Video-Qualitaetsstufen nach Anzahl aktiver Gespraechs-Peers.
 * Mesh: Upload = n * Bitrate — bei groesseren Runden wird pro RTCRtpSender
 * herunterskaliert (Kamera-Basis bleibt unveraendert 320x240@24).
 */
export const CALL_QUALITY_TIERS = [
    { maxPeers: 2, scaleResolutionDownBy: 1, maxBitrate: 500_000, maxFramerate: 24 },
    { maxPeers: 4, scaleResolutionDownBy: 1, maxBitrate: 350_000, maxFramerate: 24 },
    { maxPeers: 6, scaleResolutionDownBy: 2, maxBitrate: 200_000, maxFramerate: 20 },
    { maxPeers: Number.POSITIVE_INFINITY, scaleResolutionDownBy: 3, maxBitrate: 120_000, maxFramerate: 12 },
];
/** Screen-Share wird nie herunterskaliert (Textlesbarkeit), nur Bitrate gedeckelt. */
export const SCREEN_MAX_BITRATE = 1_200_000;
/** Bilder (Objekt-Typ 'picture'): Upload-Limits. */
export const IMAGE_MAX_BYTES = 1_572_864; // ~1,5 MB
export const IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
/** Wandkalender: aktueller + so viele Folgemonate. */
export const CALENDAR_MONTHS_AHEAD = 2;
/** Raumschild: maximal so viele Namen, danach "+N". */
export const ZONE_SIGN_MAX_NAMES = 3;
/** Aktualisierungsintervall der Zonen-Belegung (Raumschilder/Banner). */
export const ZONE_OCCUPANCY_INTERVAL_MS = 500;
/** Standard-Map, die beim ersten Start angelegt wird. */
export const DEFAULT_MAP_ID = 'default';
/** Interaktionsreichweite (Tiles), falls ein Objekt nichts anderes definiert. */
export const DEFAULT_INTERACT_RADIUS = 1.5;
//# sourceMappingURL=constants.js.map